<template>
  <div v-if="activeUserInfo.name" class="the-navbar__user-meta flex items-center">
    <div class="text-right leading-24 hidden sm:block">
      <p class="text-sm">
        {{ activeUserInfo.name }}
      </p>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="activeUserInfo.photoURL"
          :src="activeUserInfo.photoURL"
          alt="user-img"
          width="45"
          height="45"
          class="cursor-pointer block"
        >
      </div>

      <vs-dropdown-menu  class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <i-logout style="fill: currentColor;"/>
            <span class="ml-2">Выйти</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ILogout from '@/assets/svg/icons/logout.svg';

export default {
  components: {
    ILogout,
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    ...mapActions({
      logout: 'logout',
    }),
  },
};
</script>
